import { NgModule } from '@angular/core';
import { MainExportsComponent} from "./components/main-exports.component";
import { ExportUsersComponent} from "./components/dummy/users-exports.component";
import { ExportServicesComponent} from "./components/dummy/services-exports.component";
import { ExportBillsComponent} from "./components/dummy/bills-exports.component";
import { ExportCleanersComponent} from "./components/dummy/cleaners-exports.component";
import { CommonModule } from '@angular/common';
import { ExportsRoutes } from './exports.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {SharedModule} from "../../common/shared.module";
import { ExportsService } from "../../injections/exports.service";


@NgModule({
    imports: [CommonModule,
    ExportsRoutes,
    JsonpModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpModule,
    SharedModule,
    ],
    exports: [],
    declarations: [MainExportsComponent, ExportUsersComponent, ExportServicesComponent, ExportBillsComponent, ExportCleanersComponent],
    providers: [ExportsService],
})
export class ExportsModule { }



// WEBPACK FOOTER //
// ./src/app/modules/exports/exports.module.ts